import LocationGroupType from "./LocationGroupType";
const LocationType = Object.freeze({
  LOCALITY: "LOCALITY",
  WARD: "WARD",
  WARD__YSA: "WARD__YSA",
  WARD__YSA_JR: "WARD__YSA_JR",
  WARD__YSA_SR: "WARD__YSA_SR",
  WARD__ASIAN_YSA: "WARD__ASIAN_YSA",
  WARD__CAMBODIAN: "WARD__CAMBODIAN",
  WARD__CANTONESE: "WARD__CANTONESE",
  WARD__CHINESE: "WARD__CHINESE",
  WARD__CHUUKIC_POHNPEIC: "WARD__CHUUKIC_POHNPEIC",
  WARD__DEAF: "WARD__DEAF",
  WARD__DINKA_NUER: "WARD__DINKA_NUER",
  WARD__ENGLISH: "WARD__ENGLISH",
  WARD__FIJIAN: "WARD__FIJIAN",
  WARD__FILIPINO: "WARD__FILIPINO",
  WARD__FRENCH: "WARD__FRENCH",
  WARD__FRENCH_YSA: "WARD__FRENCH_YSA",
  WARD__GERMAN: "WARD__GERMAN",
  WARD__HAITIAN_CREOLE: "WARD__HAITIAN_CREOLE",
  WARD__HMONG: "WARD__HMONG",
  WARD__JAPANESE: "WARD__JAPANESE",
  WARD__KAREN: "WARD__KAREN",
  WARD__KIRIBATI: "WARD__KIRIBATI",
  WARD__KOREAN: "WARD__KOREAN",
  WARD__LAOTIAN: "WARD__LAOTIAN",
  WARD__MALAY: "WARD__MALAY",
  WARD__MANDARIN: "WARD__MANDARIN",
  WARD__MAORI: "WARD__MAORI",
  WARD__MARSHALLESE: "WARD__MARSHALLESE",
  WARD__MILITARY: "WARD__MILITARY",
  WARD__MONGOLIAN: "WARD__MONGOLIAN",
  WARD__NATIVE_AMERICAN: "WARD__NATIVE_AMERICAN",
  WARD__NEPALI: "WARD__NEPALI",
  WARD__NIUEAN: "WARD__NIUEAN",
  WARD__PERSIAN: "WARD__PERSIAN",
  WARD__POHNPEIAN: "WARD__POHNPEIAN",
  WARD__PORTUGUESE: "WARD__PORTUGUESE",
  WARD__RUSSIAN: "WARD__RUSSIAN",
  WARD__SAMOAN: "WARD__SAMOAN",
  WARD__SEASONAL: "WARD__SEASONAL",
  WARD__SINGLE_ADULT: "WARD__SINGLE_ADULT",
  WARD__SLOVAK: "WARD__SLOVAK",
  WARD__SPANISH: "WARD__SPANISH",
  WARD__SPANISH_YSA: "WARD__SPANISH_YSA",
  WARD__SPANISH_STUDENT_MARRIED: "WARD__SPANISH_STUDENT_MARRIED",
  WARD__STUDENT: "WARD__STUDENT",
  WARD__STUDENT_MARRIED: "WARD__STUDENT_MARRIED",
  WARD__STUDENT_SINGLE: "WARD__STUDENT_SINGLE",
  WARD__SWAHILI: "WARD__SWAHILI",
  WARD__TAGALOG: "WARD__TAGALOG",
  WARD__TONGAN: "WARD__TONGAN",
  WARD__TONGAN_YSA: "WARD__TONGAN_YSA",
  WARD__TRANSITIONAL: "WARD__TRANSITIONAL",
  WARD__UKRAINIAN: "WARD__UKRAINIAN",
  WARD__VIETNAMESE: "WARD__VIETNAMESE",
  WARD__VISITOR: "WARD__VISITOR",
  STAKE: "STAKE",
  STAKE__YSA: "STAKE__YSA",
  STAKE__ENGLISH: "STAKE__ENGLISH",
  STAKE__FRENCH: "STAKE__FRENCH",
  STAKE__MILITARY: "STAKE__MILITARY",
  STAKE__SPANISH: "STAKE__SPANISH",
  STAKE__STUDENT_MARRIED: "STAKE__STUDENT_MARRIED",
  STAKE__TONGAN: "STAKE__TONGAN",
  STAKE__VIETNAMESE: "STAKE__VIETNAMESE",
  TEMPLE_DISTRICT: "TEMPLE_DISTRICT",
  MISSION: "MISSION",
  MISSION__FUTURE: "MISSION__FUTURE",
  AREA: "AREA",
  EMPLOYMENT_SERVICES_AREA: "EMPLOYMENT_SERVICES_AREA",
  EMPLOYMENT_SERVICES_REGION: "EMPLOYMENT_SERVICES_REGION",
  FM_GROUP: "FM_GROUP",
  COORDINATING_COUNCIL: "COORDINATING_COUNCIL",
  TEACHING_AREA: "TEACHING_AREA",
  TEACHING_DISTRICT: "TEACHING_DISTRICT",
  TEACHING_ZONE: "TEACHING_ZONE",
  CUSTOM__MISSION: "CUSTOM__MISSION",
  STAKE_OFFICE: "STAKE_OFFICE",
  MEETINGHOUSE: "MEETINGHOUSE",
  MEETINGHOUSE__FULL: "MEETINGHOUSE__FULL",
  MEETINGHOUSE__OVER: "MEETINGHOUSE__OVER",
  MEETINGHOUSE__UNDER: "MEETINGHOUSE__UNDER",
  MEETINGHOUSE__CONSTRUCTION: "MEETINGHOUSE__CONSTRUCTION",
  MEETINGHOUSE__DESIGN: "MEETINGHOUSE__DESIGN",
  MEETINGHOUSE__FUTURE: "MEETINGHOUSE__FUTURE",
  MEETINGHOUSE__NO_UNITS: "MEETINGHOUSE__NO_UNITS",
  MEETINGHOUSE__DISCONTINUED: "MEETINGHOUSE__DISCONTINUED",
  MEETINGHOUSE__EXCESS: "MEETINGHOUSE__EXCESS",
  MEETINGHOUSE__UNKNOWN: "MEETINGHOUSE__UNKNOWN",
  MEETINGHOUSE__LICENSED_USE: "MEETINGHOUSE__LICENSED_USE",
  TEMPLE: "TEMPLE",
  TEMPLE__ANNOUNCED: "TEMPLE__ANNOUNCED",
  TEMPLE__CONSTRUCTION: "TEMPLE__CONSTRUCTION",
  TEMPLE__OPENING_SOON: "TEMPLE__OPENING_SOON",
  TEMPLE__RENOVATION: "TEMPLE__RENOVATION",
  MISSION_OFFICE: "MISSION_OFFICE",
  MISSION_HOME: "MISSION_HOME",
  AREA_OFFICE: "AREA_OFFICE",
  FAMILYSEARCH_CENTER: "FAMILYSEARCH_CENTER",
  FAMILYSEARCH_CENTER__AFFILIATE: "FAMILYSEARCH_CENTER__AFFILIATE",
  INSTITUTE: "INSTITUTE",
  SEMINARY: "SEMINARY",
  FAMILY_SERVICES: "FAMILY_SERVICES",
  EMPLOYMENT_CENTER: "EMPLOYMENT_CENTER",
  DESERET_INDUSTRIES: "DESERET_INDUSTRIES",
  BISHOPS_STOREHOUSE: "BISHOPS_STOREHOUSE",
  HOME_STORAGE_CENTER: "HOME_STORAGE_CENTER",
  CANNERY: "CANNERY",
  DISTRIBUTION_CENTER: "DISTRIBUTION_CENTER",
  DEVELOPMENT_COUNSELING: "DEVELOPMENT_COUNSELING",
  IMMIGRANT_SERVICES: "IMMIGRANT_SERVICES",
  VISITORS_CENTER: "VISITORS_CENTER",
  HISTORIC_SITE: "HISTORIC_SITE",
  TABERNACLE: "TABERNACLE",
  LURC: "LURC",
  PAVILION: "PAVILION",
  RECREATIONAL_CAMP: "RECREATIONAL_CAMP",
  STAKE_GROWTH: "STAKE_GROWTH",
  MEMBER_DENSITY: "MEMBER_DENSITY",
  HOUSEHOLD: "HOUSEHOLD",
  INDIVIDUAL: "INDIVIDUAL",
  // layer groupings shortcuts
  ...LocationGroupType
});
export default LocationType;